import React from 'react';
import PropTypes from 'prop-types';
import Modal from '../_utils/modal';
import ProductPrice from '../_utils/product-price';
import PreviewableDeliveryOptions from './previewable-delivery-options';
import PhotobookPreview from './photobook-preview';
import modalContentType from './types/modal-content-type';
import deliveryOptionType from './types/delivery-option-type';

const PhotobookModal = props => {
  const { handleModalClose, open, modalContent, deliveryOptions } = props;

  return (
    <Modal
      open={open}
      close
      turnOffBackgroundClose
      onClose={handleModalClose}
      maxWidth={720}
      actions={
        <div
          className="photobook_modal"
          data-test-id="shelf-category-products-modal">
          <div className="container">
            <h2 data-test-id="photobook-modal-title">
              {modalContent.themeTitle}
            </h2>
            <hr />
            <div
              data-test-id="photobook-preview"
              className={`photobook_modal_image ${modalContent.orientation}`}>
              <div className="photobook_modal_image_container">
                <PhotobookPreview
                  previewImages={modalContent.previewImages}
                  orientation={modalContent.orientation}
                />
              </div>
              <span data-test-id="photobook-modal-hint">
                Click or drag pages to preview this design
              </span>
            </div>
          </div>
          <div className="photobook_modal_body">
            <PreviewableDeliveryOptions
              deliveryOptions={deliveryOptions}
              deliveryOptionKeys={modalContent.deliveryOptionKeys}
            />
            <div className="photobook_modal_button">
              <ProductPrice {...modalContent.priceInfo} />
              <button
                type="button"
                onClick={e => {
                  e.preventDefault();
                  window.location.assign(modalContent.url);
                }}
                data-test-id="select-grouped-category-button"
                className="btn btn-primary btn-lg">
                Select
              </button>
            </div>
          </div>
        </div>
      }
    />
  );
};

PhotobookModal.propTypes = {
  handleModalClose: PropTypes.func.isRequired,
  modalContent: modalContentType.isRequired,
  open: PropTypes.bool.isRequired,
  deliveryOptions: PropTypes.arrayOf(deliveryOptionType).isRequired,
};

export default PhotobookModal;
